import { useState, useEffect } from "react";

interface DropdownOption {
  value: string;
  label: string;
}

interface ProfileFieldDropdownBalancedProps {
  label: string;
  value?: string;
  options: DropdownOption[];
  isRequired: boolean;
  isEditing: boolean;
  onEdit: () => void;
  onSave: (value: string) => void;
  onCancel: () => void;
  saveStatus?: 'idle' | 'saving' | 'saved' | 'error';
}

export function ProfileFieldDropdownBalanced({
  label,
  value,
  options,
  isRequired,
  isEditing,
  onEdit,
  onSave,
  onCancel,
  saveStatus = 'idle'
}: ProfileFieldDropdownBalancedProps) {
  const [editValue, setEditValue] = useState(value || '');
  
  useEffect(() => {
    setEditValue(value || '');
  }, [value]);

  const handleSave = () => {
    if (isRequired && !editValue) {
      alert(`${label} is required`);
      return;
    }
    onSave(editValue);
  };

  const selectedOption = options.find(option => option.value === value);
  
  const getSaveStatusText = () => {
    switch (saveStatus) {
      case 'saving':
        return <span className="status-text saving">Saving...</span>;
      case 'saved':
        return <span className="status-text saved">Saved</span>;
      case 'error':
        return <span className="status-text error">Error</span>;
      default:
        return null;
    }
  };

  return (
    <div className="profile-field-balanced">
      <div className="field-label-container-balanced">
        <label className="field-label-balanced">
          {label}
          {isRequired && <span className="required-indicator">*</span>}
        </label>
        {getSaveStatusText()}
      </div>

      <div className="field-container-balanced">
        {isEditing ? (
          <div className="edit-mode-balanced">
            <select
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
              className="field-select-balanced"
              autoFocus
              disabled={saveStatus === 'saving'}
            >
              <option value="">Select {label}</option>
              {options.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <div className="edit-actions-balanced">
              <button 
                onClick={handleSave} 
                className="save-button-balanced"
                disabled={saveStatus === 'saving'}
              >
                Save
              </button>
              <button 
                onClick={onCancel} 
                className="cancel-button-balanced"
                disabled={saveStatus === 'saving'}
              >
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <div className="field-display-container-balanced">
            <div 
              className="field-display-box-balanced"
              onClick={onEdit}
            >
              {selectedOption?.label ? (
                <span className="field-value-text">{selectedOption.label}</span>
              ) : (
                <span className="field-placeholder-text">Select {label}</span>
              )}
            </div>
            <button 
              className="edit-action-balanced"
              onClick={onEdit}
            >
              {value ? 'Edit' : 'Select'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}